<div *ngIf="attachment">
  <div class="dialog-box">
      <div class="mat-dialog-title" mat-dialog-title>
          <div id="lblHeading">
              ATTACHMENT
              <i class="fa fa-times-circle pull-right" (click)="togglePopupDialog()" aria-hidden="true"></i>
          </div>
      </div>
  </div>
  <div mat-dialog-content class="">
      <div class="row m-0 eip-pb-20">
          <div [ngClass]="{'kgrid-fullscreen' : enableFullscreen}" *ngIf="documentList.length>0">
              <kendo-grid #docGrid [kendoGridBinding]="documentList" [style.maxHeight]="540" [pageable]="false" id="ArForActionLandingGrid" [sortable]="true" [resizable]="true" [reorderable]="false" [filterable]="false" [scrollable]="true" class="form-group-grid auto-complete-equal kg-hover-icon k-resizable-grid">
                  <ng-template kendoPagerTemplate>
                      <div class="k-pager-left">
                          <kendo-pager-info></kendo-pager-info>
                      </div>
                      <div class="k-pager-right">
                          <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                          <kendo-pager-input></kendo-pager-input>
                          <kendo-pager-next-buttons></kendo-pager-next-buttons>
                      </div>
                  </ng-template>
                  <ng-template kendoGridToolbarTemplate>
                      <div class="k-grid-toolbar-content d-flex align-content-center">
                          <div class="flex-grow-1 title-container">
                              <p class="title">Documents</p>
                          </div>
                      </div>
                  </ng-template>
                  <kendo-grid-column title="Sl.No." filterable="false" width="60">
                      <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                          {{rowIndex+1}}
                      </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column field="documentNo" title="Document No." width="150">
                      <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                          <span class="no-wrap" eipTooltip="{{dataItem.documentNo}}" eipTooltipPosition="auto">
                              {{dataItem.documentNo}}</span>
                      </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column field="title" title="Title" width="150">
                      <ng-template kendoGridCellTemplate let-dataItem>
                          <span class="no-wrap" eipTooltip=" {{dataItem.title}}" eipTooltipPosition="auto">
                              {{dataItem.title}}
                          </span>
                      </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column field="revision" title="Revision" width="80" id="glblASRFRequiredQuantity" [minResizableWidth]="90">
                      <ng-template kendoGridHeaderTemplate let-dataItem="dataItem">
                          Revision
                      </ng-template>
                      <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                          <span class="no-wrap" eipTooltip="{{dataItem.revision}}" eipTooltipPosition="auto">{{dataItem.revision}}</span>
                      </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column field="createdBy" title="Created By" width="150">
                      <ng-template kendoGridHeaderTemplate let-dataItem="dataItem">
                          Created By
                      </ng-template>
                      <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                          <span class="no-wrap" eipTooltip="{{dataItem.createdBy}}" eipTooltipPosition="auto">{{dataItem.createdBy}}</span>
                      </ng-template>
                  </kendo-grid-column>
              </kendo-grid>
          </div>
          <div [ngClass]="{'kgrid-fullscreen' : enableFullscreen}" *ngIf="messageList.length>0">
              <kendo-grid #docGrid [kendoGridBinding]="messageList" [style.maxHeight]="540" [pageable]="false" id="ArForActionLandingGrid" [sortable]="true" [resizable]="true" [reorderable]="false" [filterable]="false" [scrollable]="true" class="form-group-grid auto-complete-equal kg-hover-icon k-resizable-grid">
                  <ng-template kendoPagerTemplate>
                      <div class="k-pager-left">
                          <kendo-pager-info></kendo-pager-info>
                      </div>
                      <div class="k-pager-right">
                          <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                          <kendo-pager-input></kendo-pager-input>
                          <kendo-pager-next-buttons></kendo-pager-next-buttons>
                      </div>
                  </ng-template>
                  <ng-template kendoGridToolbarTemplate>
                      <div class="k-grid-toolbar-content d-flex align-content-center">
                          <div class="flex-grow-1 title-container">
                              <p class="title">Messages</p>
                          </div>
                      </div>
                  </ng-template>
                  <kendo-grid-column title="Sl.No." filterable="false" width="60">
                      <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                          {{rowIndex+1}}
                      </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column field="messageNumber" title="Message No." width="100">
                      <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                          <span class="no-wrap" eipTooltip="{{dataItem.messageNumber}}" eipTooltipPosition="auto">
                              {{dataItem.messageNumber}}</span>
                      </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column field="messageSubject" title="Title" width="150">
                      <ng-template kendoGridCellTemplate let-dataItem>
                          <span class="no-wrap" eipTooltip="{{dataItem.messageSubject}}" eipTooltipPosition="auto">
                              {{dataItem.messageSubject}}
                          </span>
                      </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column field="from" title="From" width="100" id="glblASRFRequiredQuantity" headerClass="k-grid-header-column-right" [minResizableWidth]="100">
                      <ng-template kendoGridHeaderTemplate let-dataItem="dataItem">
                          From
                      </ng-template>
                      <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                          <span class="k-grid-column-right eip-link">{{dataItem.from}}</span>
                      </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column field="to" title="To" width="100">
                      <span class="no-wrap" eipTooltip="{{dataItem.to}}" eipTooltipPosition="auto">
                          {{dataItem.to}}</span>
                  </kendo-grid-column>
                  <kendo-grid-column field="status" title="Status" width="100">
                      <span class="no-wrap" eipTooltip="{{dataItem.status}}" eipTooltipPosition="auto">{{dataItem.status}}</span>
                  </kendo-grid-column>
              </kendo-grid>
          </div>

      </div>
  </div>
</div>
<div *ngIf="mailsection">
  <div mat-dialog-title>
      <div class="row">
          <div class="col-11">
              <div class="row">
                  <div class="col-7">
                      <p>Document No : {{docNo}} :</p>
                  </div>
                  <div class="col-5 mtm-10  auto-complete-equal transmittal">
                      <mat-form-field class="doc-mat-form-field eip-pl-10">
                          <mat-select [(ngModel)]="selectedMailType" style="color:white !important" (selectionChange)="filterMailType($event)">
                              <mat-option [value]="1">Mail</mat-option>
                              <mat-option [value]="2">Transmittal</mat-option>
                          </mat-select>
                      </mat-form-field>
                  </div>
              </div>
          </div>
          <div class="col-1">
              <i id="ibtClose" class="fa fa-times-circle pull-right" (click)="closeDialog()" aria-hidden="true"></i>
          </div>
      </div>
  </div>
  <div mat-dialog-content>
      <kendo-grid [kendoGridBinding]="filteredList" class="eip-pb-20 k-resizable-grid" [sortable]="false" [resizable]="false" [reorderable]="false" [pageable]="false" id="grvStatusList" [resizable]="true" width="540">
          <kendo-grid-column title="Letter No" field="messageNumber" width="250">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                  <span class="no-wrap eip-link" eipTooltip="{{dataItem.messageNumber}}" (click)="ViewMail(dataItem)" eipTooltipPosition="auto">
                      {{dataItem.messageNumber}}</span>
              </ng-template>
          </kendo-grid-column>
          <kendo-grid-column title="Subject" field="messageSubject" width="120">
              <ng-template kendoGridCellTemplate let-dataItem>
                  <span eipTooltip="{{dataItem.messageSubject}}" eipTooltipPosition="auto">{{dataItem.messageSubject}}</span>
              </ng-template>
          </kendo-grid-column>
          <kendo-grid-column title="From" field="from" width="150">
              <ng-template kendoGridCellTemplate let-dataItem>
                  <span eipTooltip="{{dataItem.from}}" eipTooltipPosition="auto">{{dataItem.from}}</span>
              </ng-template>
          </kendo-grid-column>
          <kendo-grid-column title="To" field="to" width="160">
              <ng-template kendoGridCellTemplate let-dataItem>
                  <span eipTooltip="{{dataItem.to}}" eipTooltipPosition="auto">{{dataItem.to}}</span>
              </ng-template>
          </kendo-grid-column>
          <kendo-grid-column title="Sent On" field="sentOn" width="110">
              <ng-template kendoGridCellTemplate let-dataItem>
                  <span eipTooltip="{{dataItem.sentOn | date:'dd-MMM-yyyy'}}" eipTooltipPosition="auto">{{dataItem.sentOn | date:'dd-MMM-yyyy'}}</span>
              </ng-template>
          </kendo-grid-column>
          <kendo-grid-column title="Respond By" field="respondBy" *ngIf="show" width="110">
              <ng-template kendoGridCellTemplate let-dataItem>
                  <span eipTooltip="{{dataItem.respondBy | date:'dd-MMM-yyyy'}}" eipTooltipPosition="auto">{{dataItem.respondBy | date:'dd-MMM-yyyy'}}</span>
              </ng-template>
          </kendo-grid-column>
          <kendo-grid-column title="Status" field="status" *ngIf="show" width="120">
              <ng-template kendoGridCellTemplate let-dataItem>
                  <span eipTooltip="{{dataItem.status}}" eipTooltipPosition="auto">{{dataItem.status}}</span>
              </ng-template>
          </kendo-grid-column>
      </kendo-grid>
  </div>
</div>